import { currencySymbol, numberWithCommas } from "../../../../constants/utils";
import classNames from "classnames";
import "../print.css";
import { BarcodeProductItemProps, OldFormatBarcodeProps } from "../interface";
import "./barcodeStyle.scss";
import atoms from "../../../atoms";
import constant from "../../../../constants/constant";

const { GenerateBarcode } = atoms;

export const StandardBarcode = ({
  item,
  togglePrice,
  index,
  store_region,
  showStoreName = true,
}: OldFormatBarcodeProps) => {
  // Retrieve region code from localStorage and convert it to a number
  const regionCode: boolean =
    Number(store_region) === constant.STORE_REGION.KUWAIT;
  // to generate product id display
  const generateProductID = ({
    modelNo,
    colorCode,
    size,
    isPolarized,
  }: BarcodeProductItemProps): string => {
    const polarizedSuffix = isPolarized ? "_P" : "";
    return `${modelNo}_${colorCode}_${size}${polarizedSuffix}`;
  };
  // end

  // Conditional class for price
  const priceClass = classNames({
    "show-barcode-price": togglePrice,
    "hide-barcode-price": !togglePrice,
  });
  // end

  // Conditional class for page brake
  const containerClass = classNames({
    "page-break": (index + 1) % 14 === 0,
  });
  // end

  // Left side
  const leftSection = (srp: number): JSX.Element => {
    const showSlash = !regionCode ;

    const formattedSRP = (
      <>
        <span className={regionCode ? "barcode-currency-symbol" : "rupee-font-size"}>
          {currencySymbol(store_region)}
        </span>{" "}
        {numberWithCommas(srp, regionCode ? 3 : undefined)}
        {showSlash && "/-"}
      </>
    );

    return (
      <div className="left-section">
        <h1 className="title text-uppercase m-0 p-0 fw-700">
          {item.brand_name} {item.product_type}
        </h1>

        <p className={`price m-0 p-0 fw-800 ${priceClass}`}>
          <span className={ "price m-0 p-0"}>
            {formattedSRP}
          </span>
        </p>

        <p className="product_id m-0 p-0 fw-600">
          {generateProductID({
            modelNo: item.modal_number,
            colorCode: item.brand_color_code,
            size: item.glass_size,
            isPolarized: item.isPolarized,
          })}
        </p>
      </div>
    );
  };

  //end

  // right side
  const rightSection = (): JSX.Element => {
    return (
      <div className="right-section">
        <p className="price m-0 p-0 fw-800 d-flex justify-content-center">
          {<GenerateBarcode item={item} />}
        </p>
        <p className="product_id m-0 p-0 fw-600 d-flex justify-content-center">
          {showStoreName && item.store_name}
        </p>
      </div>
    );
  };
  //end

  return (
    <div
      className={`barcode-container d-flex flex-wrap align-items-center justify-content-around ${containerClass}`}
    >
      {leftSection(item.product_srp)}
      {rightSection()}
    </div>
  );
};
